import { colorChapterOfLevel } from "./chapters.ts";
import { COLOR_CONTENT_VERSION, COLOR_PACK_LOADERS } from "./packs.generated.ts";
import { colorPackSchema, type ColorLevel, type ColorPack } from "./schema.ts";

const packCache = new Map<number, Promise<ColorPack>>();

/** Loads (once) and validates one Color Lab chapter pack; nothing of the house downloads before. */
export function loadColorChapter(chapter: number): Promise<ColorPack> {
  let pending = packCache.get(chapter);
  if (!pending) {
    const loader = COLOR_PACK_LOADERS[chapter];
    if (!loader) return Promise.reject(new Error(`no colour pack for chapter ${chapter}`));
    pending = loader().then((raw) => {
      const pack = colorPackSchema.parse(raw);
      if (pack.contentVersion !== COLOR_CONTENT_VERSION) throw new Error(`pack ${chapter} has version ${pack.contentVersion}`);
      return pack;
    });
    pending.catch(() => packCache.delete(chapter));
    packCache.set(chapter, pending);
  }
  return pending;
}

export async function loadColorLevel(levelId: number): Promise<ColorLevel> {
  const pack = await loadColorChapter(colorChapterOfLevel(levelId).chapter);
  const level = pack.levels.find((candidate) => candidate.id === levelId);
  if (!level) throw new Error(`colour level ${levelId} missing from pack`);
  return level;
}
